import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IRoomsDAO } from '../../../../api/rooms.dao';

export class GenerateRoomConnectionsJob extends JobConfiguration {
    public readonly type = JobType.GenerateRoomConnections;
    public readonly name = 'Create Zoom Connections';
    public readonly description = 'Rooms Connections Generation';

    public async execute(execParams) {
        return IoC.Container.get(IRoomsDAO).createZoomConnections(execParams);
    }
}

export default {
    [JobType.GenerateRoomConnections]: GenerateRoomConnectionsJob
};
